export const ACTIVATE_ACCOUNT_REQUESTING = 'ACTIVATE_ACCOUNT_REQUESTING'
export const ACTIVATE_ACCOUNT_SUCCESS = 'ACTIVATE_ACCOUNT_SUCCESS'
export const ACTIVATE_ACCOUNT_ERROR = 'ACTIVATE_ACCOUNT_ERROR'